/**
 * @generated SignedSource<<b21c0147ed6a6fab0fc97d453a8651f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutTaxExemption_transaction$data = {
  readonly canBeTaxExempt: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemptionCheckbox_transaction">;
  readonly " $fragmentType": "CheckoutTaxExemption_transaction";
};
export type CheckoutTaxExemption_transaction$key = {
  readonly " $data"?: CheckoutTaxExemption_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutTaxExemption_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutTaxExemption_transaction",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canBeTaxExempt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutTaxExemptionCheckbox_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "90f6fbbee692f8628c94aa8998cd2e42";

export default node;
